import { useQuery } from "@tanstack/react-query";

import client from "./client";

export interface ConfigResponse {
	genesisUrl: string;
}

const getConfig = async (): Promise<ConfigResponse> => {
	const response = await client.get("/config");

	return response.data;
};

export const useQueryConfig = () => {
	return useQuery({
		queryKey: ["config"],
		queryFn: getConfig
	});
};
